import { render, staticRenderFns } from "./renew-list.vue?vue&type=template&id=11d52bea&scoped=true&"
import script from "./renew-list.vue?vue&type=script&lang=js&"
export * from "./renew-list.vue?vue&type=script&lang=js&"
import style0 from "./renew-list.vue?vue&type=style&index=0&id=11d52bea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11d52bea",
  null
  
)

export default component.exports